import React from "react";

import { parseJwt } from "../utils/parseJwt";
import { CarsaHeader, CarsaLogo } from "../valuation-manager.styles";
import { useValuationManagerContext } from "../ValuationManagerContext";

export const Header: React.FC = () => {
  const { appInput } = useValuationManagerContext();

  const userName =
    appInput?.jwt && appInput.jwt.length > 10 ? parseJwt(appInput.jwt).unm : "";
  const link =
    "https://www.carsanet.co.uk/qualifications/edit/" +
    appInput?.qualificationId +
    "/px_basic_details";
  return (
    <CarsaHeader>
      <div className="row">
        <div className="col-sm-1 col-md-1 col-lg-1">
          <a href={link} title="Back to sales flow">
            <CarsaLogo />
          </a>
        </div>
        <div className="col-sm-10 col-md-10 col-lg-10">
          <ol className="breadcrumb">
            <li>
              <b>{userName}</b>
            </li>
            <li>{appInput?.vrm}</li>
            <li>Part Exchange</li>
          </ol>
        </div>
      </div>
    </CarsaHeader>
  );
};
